<template>
  <div class="menu-partner">
    <Header></Header>

    <b-navbar
      toggleable="md"
      style="background-color: #198754; border-radius: 4px; padding: 0"
    >
      <b-navbar-brand href="#" style="padding: 0">
        <b-button variant="success" @click="VaiA('MenuPartner')">
          <h3>{{ labels.menu_partner }}</h3>
        </b-button>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#">
            <b-button variant="success" @click="VaiA('ModificaDatiPartner')">{{
              labels.modifica_dati_partner
            }}</b-button>
          </b-nav-item>

          <b-nav-item href="#">
            <b-button variant="success" @click="VaiA('GestioneStrutture')">{{
              labels.gestione_strutture
            }}</b-button>
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item right>
            <b-button variant="success" @click="VaiA('Login')">{{
              labels.logout
            }}</b-button>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="router-view">
      <router-view />
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import store from "@/store/index";
import router from "@/router/index";

export default {
  name: "MenuPartner",
  components: {
    Header,
    Footer,
  },
  props: {},

  data() {
    return {
      labels: {},
      labels_errori: {},
      size: "sm",
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  methods: {
    VaiA(link) {
      try {
        let route = customFilter(this.$router.options.routes, link);

        if (route == undefined) {
          this.registraErrore(
            this.labels_errori.route_non_trovata,
            "MenuPartner-VaiA"
          );
          return;
        }

        let requiresAuth = false;
        let is_partner = false;
        let meta = route.meta;
        if (meta != undefined) {
          requiresAuth = meta.requiresAuth;
          is_partner = meta.is_partner;
        }

        let UtenteAutenticato = this.$store.state.UtenteAutenticato;
        let UtentePartner = this.$store.state.UtentePartner;

        if (
          (requiresAuth && !UtenteAutenticato) ||
          (is_partner && !UtentePartner)
        ) {
          this.$router.push("/login");
        } else {
          this.$router.push({ name: link, params: {} }, null, function () {});
        }
      } catch (error) {
        this.registraErrore(error, "MenuPartner-VaiA");
      }
    },
    logout() {
      try {
        this.$router.push("/login");
      } catch (error) {
        this.registraErrore(error, "MenuPartner-logout");
      }
    },
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
    } catch (error) {
      this.registraErrore(error, "MenuPartner-created");
    }
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtentePartner = store.state.UtentePartner;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_partner && !UtentePartner)
      ) {
        router.push("/login");
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      menu_partner: "Menù partner",
      modifica_dati_partner: "Modifica dati partner",
      gestione_strutture: "Gestione strutture",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };
    let labels_inglese = {
      menu_partner: "Menù partner",
      modifica_dati_partner: "Modifica dati partner",
      gestione_strutture: "Gestione strutture",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };
    let labels_tedesco = {
      menu_partner: "Menù partner",
      modifica_dati_partner: "Modifica dati partner",
      gestione_strutture: "Gestione strutture",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };
    let labels_francese = {
      menu_partner: "Menù partner",
      modifica_dati_partner: "Modifica dati partner",
      gestione_strutture: "Gestione strutture",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };

    let labels_errori_italiano = {
      route_non_trovata: "Percorso non trovato",
    };
    let labels_errori_inglese = {
      route_non_trovata: "Percorso non trovato",
    };
    let labels_errori_tedesco = {
      route_non_trovata: "Percorso non trovato",
    };
    let labels_errori_francese = {
      route_non_trovata: "Percorso non trovato",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "MenuPartner-fn_CambiaLingua");
  }
}

function customFilter(object, key) {
  try {
    for (let i = 0; i < object.length; i++) {
      if ("name" in object[i]) {
        if (object[i].name == key) {
          return object[i];
        }
      }

      if ("children" in object[i]) {
        let o = customFilter(object[i].children, key);
        if (o != null) {
          return o;
        }
      }
    }
  } catch (errore) {
    //console.log(errore);
  }
}
</script>

<style scoped>
.menu-partner {
  min-height: auto;
  margin-top: 15px;
  margin-bottom: 15px;
}

.router-view {
  min-height: 300px;
}
</style>
